import { RootState } from "store/store";

export const selectTimezone = (state: RootState) =>
  state.timezone.timezoneToken;
